import { Monitor, Moon, Sun, type LucideIcon } from 'lucide-react';
import { type Theme } from '@/stores/theme';

// Preferencias de tema en el orden en que se ofrecen (el mismo del ciclo del
// botón de la barra), con su nombre visible y el ícono que las representa.
// El botón de la barra usa el ícono; el menú del celular ofrece las tres.
export const THEMES: readonly Theme[] = ['light', 'dark', 'system'];

export const THEME_LABEL: Record<Theme, string> = {
  light: 'Claro',
  dark: 'Oscuro',
  system: 'Sistema',
};

export const THEME_ICON: Record<Theme, LucideIcon> = {
  light: Sun,
  dark: Moon,
  system: Monitor,
};

export function isTheme(value: string): value is Theme {
  return (THEMES as readonly string[]).includes(value);
}
